<template>
  <div class="list-single-active-option">
    <div
      class="list-single-active-option__option"
      :class="{ 'list-single-active-option__option--active': isActive(item) }"
      v-for="item in options"
      :key="item.code"
      @click="onSelectOption(item)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      options: any[];
      activeOption: Record<string, any>;
    }>(),
    {
      options: () => [],
      activeOption: () => ({}),
    }
  );

  const emits = defineEmits<{
    (event: 'onSelectOption', value: Record<string, any>): void;
  }>();

  const isActive = ({ sortBy, sortOrder }: Record<string, any>) => {
    return props.activeOption.sortBy === sortBy && props.activeOption.sortOrder === sortOrder;
  };

  const onSelectOption = (item: Record<string, any>) => {
    emits('onSelectOption', item);
  };
</script>

<style src="~/assets/styles/components/list/single-active-option.scss" lang="scss" />
